import React from 'react'
import { StyleService, useStyleSheet } from '@src/style/service'
import { BillingProduct } from '@src/types'
import { openUrl } from '@src/utils'
import { Text } from '@src/components/base'
import { VIDEO_CALL_POLICY_URL } from '../../constants'
import { useFeeProduct } from '../../hooks/useFeeProduct'

interface CancellationPolicyProps {
  imposesLateChangeFees: boolean
  lateCancellationFeeProduct: BillingProduct | null | undefined
}

export const CancellationPolicy = ({
  imposesLateChangeFees,
  lateCancellationFeeProduct,
}: CancellationPolicyProps) => {
  const styles = useStyleSheet(themedStyles)

  const feeProduct = useFeeProduct(lateCancellationFeeProduct)

  if (!imposesLateChangeFees || !feeProduct?.price) {
    return null
  }

  return (
    <Text type="small" style={styles.text}>
      Reschedule or cancel up to 24 hours before your call at no charge. Changes within 24 hours or
      missed calls will incur a ${feeProduct.price} fee per{' '}
      <Text type="small" bold onPress={() => openUrl(VIDEO_CALL_POLICY_URL)} style={styles.link}>
        our policy
      </Text>
      .
    </Text>
  )
}

const themedStyles = StyleService.create({
  text: {
    marginBottom: 16,
    color: 'theme.text.secondary',
  },
  link: {
    color: 'theme.text.link',
  },
})
